import React, { useState, useEffect } from 'react';
import {
  TextField, MenuItem, Button, Box, Grid, Paper,Autocomplete
} from '@mui/material';
import axios from 'axios';
import * as XLSX from "xlsx";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import LayoutAdminHeader from '../components/LayoutAdminHeader';
import LayoutAdminFooter from '../components/LayoutAdminFooter';
import GSTLoader from '../components/GSTLoader';

const BASE_URL = process.env.REACT_APP_BASE_URL;

const AdminReport = () => {
  const [gst, setGsts] = useState([]);
  const [invoices, setInvoices] = useState([]);

  const [formData, setFormData] = useState({
    gstNumber: '',
    firmName: '',
    financialYear: '',
    period: '',
    reportType: ''
  });

  useEffect(() => {
    const fetchGstNumbers = async () => {
      try {
        const token = localStorage.getItem("token");

const res = await axios.get(`${BASE_URL}/Registration/GetAllGSTNumbers`, {
  headers: {
    Authorization: `Bearer ${token}`,
  },
});
        setGsts(res.data.data || []);
      } catch (err) {
        console.error('Failed to fetch gsts:', err);
        toast.error('Failed to load GST numbers');
      }
    };
    fetchGstNumbers();
  }, []);

  // ✅ Define BEFORE return
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value
    }));
  };

const fetchFilteredInvoices = async (e) => {
  e.preventDefault();
  try {
    const token = localStorage.getItem("token");

const response = await axios.get(`${BASE_URL}/salesinvoice/filter`, {
  params: {
    gstNumber: formData.gstNumber,
    financialYear: formData.financialYear,
    period: formData.period,
  },
  headers: {
    Authorization: `Bearer ${token}`,
  },
});

    const salesInvoices = response.data.sales?.data || [];
    const purchaseInvoices = response.data.purchases?.data || [];

    console.log("Sales Invoices:", salesInvoices);
    console.log("Purchase Invoices:", purchaseInvoices);

    // ----------------- SALES INVOICE SHEET -----------------
    let salesExcelData = [];
let serialNo = 1;

// 1) Build header via AOA so !ref is set
const headerAoA = [
  ["GSTIN",          formData.gstNumber || ""],
  ["Firm Name",      formData.firmName || ""],
  ["Financial Year", formData.financialYear || ""],
  ["Period",         formData.period || ""],
];
const salesSheet = XLSX.utils.aoa_to_sheet(headerAoA); // A1:B4 filled + !ref set

// 2) Build data rows (if any)
if ((salesInvoices || []).length > 0) {
  salesInvoices
  .sort((a, b) => new Date(a.InvoiceDate) - new Date(b.InvoiceDate))
  .forEach(invoice => {
    (invoice.Products || []).forEach(product => {
      salesExcelData.push({
        "S No": serialNo++,
        "Invoice Number": invoice.InvoiceNumber,
       
       // "Date": invoice.InvoiceDate ? new Date(invoice.InvoiceDate).toLocaleDateString() : "",
       
       "Date": invoice.InvoiceDate
  ? new Date(invoice.InvoiceDate).toLocaleDateString('en-GB')
  : "",
       
       "Party Name": invoice.ReceiverDetails?.Name || "",
        "GST Number": invoice.ReceiverDetails?.GSTNumber || "",
        "State": invoice.StateId || "",
        "Item Name": product.ProductId || "",
        "HSN CODE": product.HsnSacCode || "",
        "UQC": product.UnitId || "",
        "Qnt": parseFloat(product.Quantity?.$numberDecimal || product.Quantity?.toString() || 0),
        "Rate": parseFloat(product.Rate?.$numberDecimal || product.Rate?.toString() || 0),
        "Amount Before Tax": parseFloat(product.TaxableValue?.$numberDecimal || product.TaxableValue?.toString() || 0),
        "CGST %": parseFloat(product.CGSTPercentage?.$numberDecimal || product.CGSTPercentage?.toString() || 0),
        "CGST Amount": parseFloat(product.CGSTAmount?.$numberDecimal || product.CGSTAmount?.toString() || 0),
        "SGST %": parseFloat(product.SGSTPercentage?.$numberDecimal || product.SGSTPercentage?.toString() || 0),
        "SGST Amount": parseFloat(product.SGSTAmount?.$numberDecimal || product.SGSTAmount?.toString() || 0),
        "IGST %": parseFloat(product.IGSTPercentage?.$numberDecimal || product.IGSTPercentage?.toString() || 0),
        "IGST Amount": parseFloat(product.IGSTAmount?.$numberDecimal || product.IGSTAmount?.toString() || 0),
        "Tax Invoice Amount": parseFloat(product.Total?.$numberDecimal || product.Total?.toString() || 0)
      });
    });
  });

  // 3a) Add data starting at row 6 (A6)
  XLSX.utils.sheet_add_json(salesSheet, salesExcelData, { origin: "A6" });

} else {
  // 3b) No data → write message at A6 (this also expands !ref)
  XLSX.utils.sheet_add_aoa(
    salesSheet,
    [["No Sale Invoices Present for this month"]],
    { origin: "A6" }
  );

  // (Optional) Merge message across columns A–H
  salesSheet["!merges"] = [
    { s: { r: 5, c: 0 }, e: { r: 5, c: 7 } } // A6:H6
  ];
}

    // ----------------- PURCHASE INVOICE SHEET -----------------
    let purchaseExcelData = [];
let pSerialNo = 1;

// 1) Header first via AOA (sets !ref properly)
const purchaseHeaderAoA = [
  ["GSTIN",          formData.gstNumber || ""],
  ["Firm Name",      formData.firmName || ""],
  ["Financial Year", formData.financialYear || ""],
  ["Period",         formData.period || ""],
];
const purchaseSheet = XLSX.utils.aoa_to_sheet(purchaseHeaderAoA); // A1:B4

// 2) Build data rows (if any)
if ((purchaseInvoices || []).length > 0) {
  purchaseInvoices
  .sort((a, b) => new Date(a.InvoiceDate) - new Date(b.InvoiceDate))
  .forEach(invoice => {
    (invoice.Products || []).forEach(product => {
      purchaseExcelData.push({
        "S No": pSerialNo++,
        "Invoice Number": invoice.InvoiceNumber,
       
       // "Date": invoice.InvoiceDate ? new Date(invoice.InvoiceDate).toLocaleDateString() : "",
       
       "Date": invoice.InvoiceDate
  ? new Date(invoice.InvoiceDate).toLocaleDateString('en-GB')
  : "",
       
       
        "Party Name": invoice.CustomerName || "",
        "URP / GST Number": invoice.CustomerGSTNumber || "",
        "State": invoice.StateId || "",
        "Item Name": product.ProductName || "",
        "HSN CODE": product.HSNCode || "",
        "UQC": product.Unit || "",
        "Qnt": parseFloat(product.Quantity?.$numberDecimal || product.Quantity?.toString() || 0),
        "Rate": parseFloat(product.Rate?.$numberDecimal || product.Rate?.toString() || 0),
        "Amount Before Tax": parseFloat(product.Amount?.$numberDecimal || product.Amount?.toString() || 0),
        "CGST %": parseFloat(product.CGSTPercentage?.$numberDecimal || product.CGSTPercentage?.toString() || 0),
        "CGST Amount": parseFloat(product.CGSTAmount?.$numberDecimal || product.CGSTAmount?.toString() || 0),
        "SGST %": parseFloat(product.SGSTPercentage?.$numberDecimal || product.SGSTPercentage?.toString() || 0),
        "SGST Amount": parseFloat(product.SGSTAmount?.$numberDecimal || product.SGSTAmount?.toString() || 0),
        "IGST %": parseFloat(product.IGSTPercentage?.$numberDecimal || product.IGSTPercentage?.toString() || 0),
        "IGST Amount": parseFloat(product.IGSTAmount?.$numberDecimal || product.IGSTAmount?.toString() || 0),
        "Tax Invoice Amount": parseFloat(invoice.TotalAmount?.$numberDecimal || invoice.TotalAmount?.toString() || 0)
      });
    });
  });

  // 3a) Add data at row 6
  XLSX.utils.sheet_add_json(purchaseSheet, purchaseExcelData, { origin: "A6" });

} else {
  // 3b) No data → write message at A6 (and optionally merge across columns)
  XLSX.utils.sheet_add_aoa(
    purchaseSheet,
    [["No Purchase Invoices Present for this month"]],
    { origin: "A6" }
  );

  // Optional merge A6:H6 so the message spans wide
  purchaseSheet["!merges"] = [
    { s: { r: 5, c: 0 }, e: { r: 5, c: 7 } } // A6:H6
  ];
}

    // ----------------- SUMMARY SHEET -----------------
    // ----------------- SUMMARY SHEET -----------------
// ----------------- SUMMARY SHEET (monthly, based on createdDateTime) -----------------
// ----------------- SUMMARY SHEET (improved numeric selection) -----------------

let summaryExcelData = [];

/** extract numeric groups from a string */
const extractNumericGroups = (s) => {
  if (!s || typeof s !== 'string') return [];
  const matches = s.match(/\d+/g) || [];
  return matches.map(m => ({ str: m, num: parseInt(m, 10), len: m.length }));
};

/** format date label like "Aug-25" */
const formatMonthLabel = (d) => {
  if (!(d instanceof Date)) d = new Date(d);
  if (isNaN(d)) return '';
  return d.toLocaleDateString('en-GB', { month: 'short', year: '2-digit' }).replace(' ', '-');
};

/**
 * Build monthly summary using the robust selection policy described above.
 * Pushes rows into summaryExcelData.
 */
const buildMonthlySummaryRobust = (invoices = [], type) => {
  if (!Array.isArray(invoices) || invoices.length === 0) {
    // still add zero row so both doc types show if needed
    summaryExcelData.push({
      "Nature of Document": type,
      "From": "0",
      "To": "0",
      "Total Number": 0,
      "Cancelled": 0,
      "Net issued": 0
    });
    return;
  }

  // Group by month (createdDateTime preferred, fallback to InvoiceDate)
  const groups = new Map();
  invoices.forEach(inv => {
    const dtRaw = inv.createdDateTime || inv.InvoiceDate || null;
    if (!dtRaw) return;
    const dt = new Date(dtRaw);
    if (isNaN(dt)) return;
    const key = formatMonthLabel(dt);
    if (!groups.has(key)) groups.set(key, []);
    groups.get(key).push(inv);
  });

  for (const [monthLabel, invArray] of groups.entries()) {
    // Collect numeric-group length frequencies across the month
    const lengthCounts = {};
    const perInvoiceGroups = invArray.map(inv => {
      const groupsFound = extractNumericGroups(String(inv.InvoiceNumber || ''));
      groupsFound.forEach(g => {
        lengthCounts[g.len] = (lengthCounts[g.len] || 0) + 1;
      });
      return groupsFound;
    });

    // Prefer lengths >= 3 (so we avoid 1-2 digit date fragments). If none >=3 exist, use overall mode.
    const lengths = Object.keys(lengthCounts).map(n => parseInt(n, 10));
    let preferredLen = null;
    if (lengths.length) {
      // pick the most frequent length that is >=3
      const lengthsSortedByCount = lengths.sort((a, b) => (lengthCounts[b] - lengthCounts[a]));
      preferredLen = lengthsSortedByCount.find(l => l >= 3) ?? lengthsSortedByCount[0];
    }

    // For each invoice, pick a numeric candidate according to preferredLen with safe fallbacks:
    //  - pick group with preferredLen
    //  - else pick invoice's largest-length numeric group if its length >= 3
    //  - else skip numeric selection for that invoice (do not include tiny date-like numbers)
    const chosenNumbers = [];
    const chosenDiagnostics = []; // keep for console logging
    invArray.forEach((inv, idx) => {
      const groupsFound = perInvoiceGroups[idx]; // [{str,num,len}, ...]
      let chosen = null;

      if (preferredLen != null) {
        const match = groupsFound.find(g => g.len === preferredLen);
        if (match) chosen = match.num;
      }

      if (chosen === null && groupsFound.length > 0) {
        // fallback: pick the largest-length group only if its length >= 3
        const largest = groupsFound.reduce((acc, cur) => (cur.len > (acc?.len || 0) ? cur : acc), null);
        if (largest && largest.len >= 3) {
          chosen = largest.num;
        } else {
          chosen = null; // intentionally skip tiny groups (1-2 digits)
        }
      }

      if (chosen !== null && !isNaN(chosen)) chosenNumbers.push(chosen);

      chosenDiagnostics.push({
        invoiceId: inv._id || null,
        invoiceNumber: inv.InvoiceNumber,
        groupsFound: groupsFound.map(g => g.str),
        chosen
      });
    });

    // Compute From/To using numeric chosenNumbers. If none available, fallback to first/last invoice strings.
    const fromVal = chosenNumbers.length ? Math.min(...chosenNumbers) : (invArray[0]?.InvoiceNumber || '');
    const toVal = chosenNumbers.length ? Math.max(...chosenNumbers) : (invArray[invArray.length - 1]?.InvoiceNumber || '');

    const total = invArray.length;
    const cancelled = invArray.filter(x => (x.Status || '').toString().toLowerCase() === 'cancelled').length || 0;
    const netIssued = total - cancelled;

    summaryExcelData.push({
      "Nature of Document": `${type} (${monthLabel})`,
      "From": fromVal,
      "To": toVal,
      "Total Number": total,
      "Cancelled": cancelled,
      "Net issued": netIssued
    });

    // Diagnostics log — paste if results look wrong
    console.group(`Summary Diagnostics — ${type} — ${monthLabel}`);
    console.log('Total invoices in month:', total);
    console.log('Numeric-group length counts:', lengthCounts);
    console.log('Preferred numeric length chosen:', preferredLen);
    console.log('Per-invoice chosen candidates:', chosenDiagnostics);
    console.log('Chosen numeric values used for From/To:', chosenNumbers.slice(0, 100));
    console.log('Computed From:', fromVal, ' To:', toVal);
    console.groupEnd();
  }
};

// Build for Sales (Tax Invoice) & Purchase
buildMonthlySummaryRobust(salesInvoices || [], "Tax Invoice");
buildMonthlySummaryRobust(purchaseInvoices || [], "Purchase Invoice");

// If still empty, ensure there is at least a placeholder row:
if (summaryExcelData.length === 0) {
  summaryExcelData.push({
    "Nature of Document": "Tax Invoice",
    "From": "0",
    "To": "0",
    "Total Number": 0,
    "Cancelled": 0,
    "Net issued": 0
  }, {
    "Nature of Document": "Purchase Invoice",
    "From": "0",
    "To": "0",
    "Total Number": 0,
    "Cancelled": 0,
    "Net issued": 0
  });
}

const summaryHeaderAoA = [
  ["GSTIN",          formData.gstNumber || ""],
  ["Firm Name",      formData.firmName || ""],
  ["Financial Year", formData.financialYear || ""],
  ["Period",         formData.period || ""],
];
const summarySheet = XLSX.utils.aoa_to_sheet(summaryHeaderAoA); // A1:B4 set

// Continue to create sheet exactly as you already do...
// const summarySheet = XLSX.utils.json_to_sheet(summaryExcelData.length ? summaryExcelData : [{}], { origin: "A5" });
XLSX.utils.sheet_add_json(
  summarySheet,
  summaryExcelData.length ? summaryExcelData : [{}],
  { origin: "A6" }
);


// ----------------- CREATE WORKBOOK -----------------
const workbook = XLSX.utils.book_new();
XLSX.utils.book_append_sheet(workbook, salesSheet, "Sales Invoices");
XLSX.utils.book_append_sheet(workbook, purchaseSheet, "Purchase Invoices");
XLSX.utils.book_append_sheet(workbook, summarySheet, "Summary");

// then write workbook as you already do (XLSX.writeFile or write)

    // XLSX.writeFile(workbook, "gst_report.xlsx");
// const gstSafe = (formData.gstNumber || 'GST').replace(/[^a-zA-Z0-9_-]/g, '');
// const now = new Date();
// const year = now.getFullYear(); // 2025
// const filename = `${gstSafe}_${formData.period}_${year}.xlsx`;


const gstSafe = (formData.gstNumber || 'GST')
  .replace(/[^a-zA-Z0-9_-]/g, '');

const selectedMonth = formData.period || "Month";
const selectedFinancialYear = formData.financialYear || "FY";

// Example:
// March-2024-2025.xlsx
// January-2025-2026.xlsx

const filename = `${gstSafe}_${selectedMonth}-${selectedFinancialYear}.xlsx`;


XLSX.writeFile(workbook, filename);
    toast.success("Invoices Downloaded Successfully");
  } catch (error) {
    console.error("Error fetching invoices", error);
    toast.error("Failed to load invoices");
  }
};

  return (
      <>
        <LayoutAdminHeader />
        <Box sx={{ padding: 4, backgroundColor: '#f5f5f5' }}>
          <form>
            <Paper sx={{ padding: 3, mb: 3 }}>
              <Grid container spacing={2}>
                <Grid item xs={12} sm={6}>
                <Autocomplete
  options={gst}
  getOptionLabel={(option) => option.gst}   // what to display in list
  value={gst.find((g) => g.gst === formData.gstNumber) || null}
  onChange={(e, newValue) => {
    setFormData({
      ...formData,
      gstNumber: newValue?.gst || "",
      firmName: newValue?.firmName || ""
    });
  }}
  renderInput={(params) => (
    <TextField
      {...params}
      label="GST Number"
      fullWidth
      required
      sx={{ width: "400px" }}
    />
  )}
/>
                </Grid>

                <Grid item xs={12} sm={6}>
                  <TextField
                    label="Firm Name"
                    name="firmName"
                    value={formData.firmName}
                    onChange={handleChange}
                    fullWidth
                    required
                    sx={{ width: '400px' }}
                  />
                </Grid>

                <Grid item xs={12} sm={6}>
                  <TextField
                    select
                    label="Financial Year"
                    name="financialYear"
                    value={formData.financialYear}
                    onChange={handleChange}
                    fullWidth
                    required
                    sx={{ width: '400px' }}
                  >
                    <MenuItem value="2024-2025">2024-2025</MenuItem>
                    <MenuItem value="2025-2026">2025-2026</MenuItem>
                    <MenuItem value="2026-2027">2026-2027</MenuItem>
                    <MenuItem value="2027-2028">2027-2028</MenuItem>
                    <MenuItem value="2028-2029">2028-2029</MenuItem>
                    <MenuItem value="2029-2030">2029-2030</MenuItem>
                    
                  </TextField>
                </Grid>

                <Grid item xs={12} sm={6}>
                  <TextField
                    select
                    label="Period"
                    name="period"
                    value={formData.period}
                    onChange={handleChange}
                    fullWidth
                    required
                    sx={{ width: '400px' }}
                  >
                    {[
                      "January", "February", "March", "April", "May", "June",
                      "July", "August", "September", "October", "November", "December"
                    ].map((month) => (
                      <MenuItem key={month} value={month}>
                        {month}
                      </MenuItem>
                    ))}
                  </TextField>
                </Grid>
                <Grid item xs={12} display="flex" justifyContent="center">
  <Button
    variant="contained"
    onClick={fetchFilteredInvoices}
    sx={{
      width: "300px",   
      height: "56px"   
    }}
  >
    Search
  </Button>
</Grid>
              </Grid>
            </Paper>
          </form>
        </Box>

        <ToastContainer />
      </>
  );
};

export default AdminReport;

